import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const PAM: React.FC = () => {
  const sections = [
    {
      title: 'Privileged Access Management (PAM)',
      content: 'Our PAM solutions secure, manage, and monitor privileged accounts and access across your organization. We implement comprehensive privileged access controls that reduce risk while enabling authorized users to perform their duties effectively.',
      benefits: [
        'Privileged account discovery and inventory',
        'Password vaulting and rotation',
        'Session monitoring and recording',
        'Just-in-time access provisioning',
        'Compliance reporting and audit trails'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Privileged Access Management"
      subtitle="Comprehensive PAM solutions to secure and manage privileged accounts and access across your organization."
      sections={sections}
    />
  );
};

export default PAM;

